module.exports = __webpack_public_path__ + "static/media/profileUnknown.48ee0f65.svg";